import React from 'react'

const Brand = () => {
  return (
    <img className="h-16 rounded-full" src={require('../images/logo.jpg')} alt="1stVPNServices" />
  )
}

export default Brand